export const isPhoneApp = navigator.userAgent.includes("LinkShulMobile/1");

export function AppLogo({ size }) {
  return <img src="/assets/linkshul-logo.png" alt="LinkShul" width={size} height={size} style={{ objectFit: "contain", borderRadius: 8 }} />;
}